import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomeScreen from "./screens/HomeScreen";
import LoginScreen from "./screens/LoginScreen";
import LoginUserScreen from "./screens/LoginUserScreen";
import UserScreen from "./screens/UserScreen";
import ManageScreen from "./screens/ManageScreen";
import "./App.css";
import StudentDashboard from "./screens/StudentDashboard";
import SidebarLayout from "./screens/SidebarLayout";
import Chatbot from "./components/Chatbot";
const UserScreenWithChatbot = () => {
  return (
    <>
      <UserScreen />
      <Chatbot />
    </>
  );
};

function App() {
  const isAuthenticated = localStorage.getItem("loggedIn") === "true";
  const isUser = localStorage.getItem("loggedIn") === "true";
  const isAdmin =
    localStorage.getItem("type") == "admin" ||
    localStorage.getItem("type") == "superadmin" ||
    localStorage.getItem("type") == "bcom" ||
    localStorage.getItem("type") == "city_manager" ||
    localStorage.getItem("type") == "state_manager"||
    localStorage.getItem("type") == "query_manager";
  // localStorage.getItem("type") == "bcom";
  console.log("isAuthenticated:", isAuthenticated);
  console.log("isUser:", isUser);
  console.log("isAdmin:", isAdmin);

  return (
    <>
      <Router>
        <Routes>
          {isAuthenticated && isUser ? (
            // <Route path="/" element={<UserScreen />} />
            <Route path="/" element={<UserScreenWithChatbot />} />
          ) : (
            <Route path="/" element={<LoginUserScreen />} />
          )}
          {isAuthenticated && isUser && isAdmin ? (
            <>
              <Route path="/admin" element={<HomeScreen />} />
              <Route path="/student-dashboard" element={<StudentDashboard />} />
            </>
          ) : (
            <Route path="/admin" element={<LoginScreen />} />
          )}
          {isAuthenticated && isUser ? (
            <Route path="/manage" element={<ManageScreen />} />
          ) : (
            <Route path="/manage" element={<LoginScreen />} />
          )}
          <Route path="*" element={<LoginUserScreen />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
